// extracted by mini-css-extract-plugin
module.exports = {"megaMenu":"MegaMenu_megaMenu__3b_b4","open":"MegaMenu_open__SXO2k"};